import { type Ref } from "react";

import { type BestQuickPicks } from "@/lib/api/best/quick-picks/schema";
import { cn } from "@/lib/utils";

import type { Category } from "../categories";
import { QuickPicks } from "../quick-picks/mobile/quick-picks";
import { CategoryItem } from "./mobile-category-item";

type Props = {
  isActive: boolean;
  ref: Ref<HTMLDivElement>;
  onDrillDown: (index: number) => void;
  quickPicksItems: BestQuickPicks | null;
  categories: Category[];
};

export function MobileRootPanel({
  isActive,
  ref,
  onDrillDown,
  quickPicksItems,
  categories,
}: Props) {
  return (
    <div
      ref={ref}
      tabIndex={-1}
      className={cn(
        "absolute inset-0 overflow-y-auto flex flex-col px-5 transition-all duration-200 ease-out outline-none",
        !isActive && "-translate-x-1/4 opacity-0",
      )}
      inert={!isActive || undefined}
    >
      <nav className="pt-6">
        <ul className="flex flex-col gap-6">
          {categories.map((category, index) => (
            <li key={category.name}>
              <CategoryItem
                item={category}
                onDrillDown={() => onDrillDown(index)}
              />
            </li>
          ))}
        </ul>
      </nav>

      {quickPicksItems && (
        <div className="shrink-0 pt-10 pb-6">
          <QuickPicks items={quickPicksItems} />
        </div>
      )}
    </div>
  );
}
